export { useSkeletonItemBase_unstable as useSkeletonItem } from '@fluentui/react-skeleton';
